export function parseTelemetryTimestamp(value: unknown): Date | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  let raw = String(value).trim();
  if (!raw || raw === 'undefined' || raw === 'null') {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(raw)) {
    raw = raw.replace(' ', 'T');
  }

  let parsed = new Date(raw);

  if (!Number.isNaN(parsed.getTime())) {
    const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2}|GMT|UTC)$/i.test(raw);
    if (!hasTimezone) {
      parsed = new Date(raw + 'Z');
    }
  }

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function secondsSinceTelemetryTimestamp(value: unknown, now: Date = new Date()): number | null {
  const parsed = parseTelemetryTimestamp(value);
  if (!parsed || Number.isNaN(now.getTime())) {
    return null;
  }

  return Math.floor((now.getTime() - parsed.getTime()) / 1000);
}
